module.exports = __webpack_public_path__ + "media/images/png/house-89611493b881daac2fe4f222263771b3.png";